export const errorMessage = {
  required: 'Campo obrigatório.',
  cpfFormat: 'Tem algo errado com o formato desse número. Tente de novo.',
  emailFormat: 'Esse e-mail não está no formato certo. Tente de novo.',
  emailDifferent: 'Para alterar o email você precisa confirmar o novo email.',
  different: 'Parece que você ainda não decorou seu email. Tente novamente.'
}



// WEBPACK FOOTER //
// ./src/utils/dictionary.js